import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faCopy, faEnvelope, faEye, faPrint } from "@fortawesome/free-solid-svg-icons";
import styles from "./style.module.scss";
import moment from "moment";
import { ProviderOrderApi, ProviderOrderDataType } from "@/api/ProviderOrderApi";
import { OpenSendDocumentPubSub } from "@utils/pubsubs/PubSub";
import SendDocumentToEmailOffCanvas from "@components/layout/Offcanvas/SendDocumentToEmailOffCanvas";
import { useAppSelector } from "@/store/hooks";
import { ProviderApi } from "@/api/ProviderApi";

const ProviderOrderIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const suscriptionData = useAppSelector(state => state.suscription.suscription)

  useEffect(() => {
  }, []);

  const triggerEmailSend = async (item: ProviderOrderDataType) => {
    const provider = await ProviderApi.get(`${item.providerId}`)

    OpenSendDocumentPubSub.publish({
      openOffCanvas: true,
      emails: provider.email || "",
      sourceURL: `/user/providerorders/print/${item.id}/0/1`,
      emailProps: {
        emailBody: suscriptionData?.qoute_email || "",
        emailFilename: `Orden de Compra #${item.numero}`,
        emailSubject: `Orden de Compra #${item.numero}`,
        Suscription: {
          email: suscriptionData?.email || ""
        }
      }
    })
  }

  return (
    <PageContainer
      title="Lista Ordenes de Compra Provedores"
      backUrl="/user/dashboard"
      primaryActions={[
        {
          onClick: () => {
            navigate('/user/providerorders/add')
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<ProviderOrderDataType>
        ref={modelRef}
        meiliConfig={{
          index: "providerorders",
          sort: ["numero:desc"]
        }}
        messages={{
          noResults: "No hay Ordenes de compra creadas aun"
        }}
        fetchData={(...args) => ProviderOrderApi.fetchAll(...args)}
        filterProps={[
          {
            key: "providerNombre",
            filterType: "contains"
          },
          {
            key: "numero",
            filterType: "eq",
            type: "number"
          }
        ]}
        primaryProperties={[
          {
            key: "numero",
            highlighted: true,
            className: styles.sequence
          },
          {
            key: (d) => d.providerNombre,
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "2", xs: "12" },
            { sm: "10", xs: "12" }
          ]
        }
        secondaryProperties={[
          {
            key: (data) => {
              const date = moment(data.fecha, "YYYY-MM-DD")
              return date.format("DD-MM-YYYY")
            },
            title: "Fecha",
          },
          {
            key: "pedidoPor",
            title: "Pedido por"
          },
          {
            key: "entregarA",
            title: "Entregado a"
          },

        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "4", md: "3" },
            { sm: "4", md: "2" }
          ]
        }
        includeCustomFields={true}
        listActions={[
          {
            href: "/user/providerorders/copy/{:id}",
            actionTitle: "Copiar de Orden de Compra",
            iconProps: { icon: faCopy }
          },
          {
            onClick: (id, item) => triggerEmailSend(item),
            actionTitle: "Enviar Por Correo ",
            iconProps: { icon: faEnvelope }
          },
          {
            href: "/user/providerorders/view/{:id}",
            actionTitle: "Ver Orden de Compra",
            target: "_blank",
            iconProps: { icon: faEye }
          },
          {
            href: "/user/providerorders/print/{:id}/0/1",
            actionTitle: "Imprimir Orden de Compra",
            target: "_blank",
            iconProps: { icon: faPrint }
          }
        ]}
      >
      </ModelIndex>

      <SendDocumentToEmailOffCanvas
        title="Envio de Orden de Compra por Email" />

    </PageContainer >
  );
}

export default ProviderOrderIndex;
